var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4201 16.2593C12.9101 17.4593 11.0101 18.0093 9.10007 17.7893C7.18007 17.5693 5.46007 16.6193 4.26007 15.1093C3.54007 14.2093 3.06007 13.1793 2.83007 12.0693C2.72007 11.5293 2.20007 11.1793 1.65007 11.2893C1.11007 11.3993 0.760069 11.9293 0.870069 12.4693C1.16007 13.8993 1.78007 15.2093 2.69007 16.3593C4.23007 18.2893 6.42007 19.5093 8.87007 19.7793C9.23007 19.8193 9.58007 19.8393 9.93007 19.8393C12.0101 19.8393 14.0101 19.1393 15.6601 17.8293C19.6401 14.6593 20.3001 8.83929 17.1301 4.85929C14.0801 1.00929 8.57007 0.269286 4.60007 3.06929L5.04007 1.57929C5.20007 1.04929 4.90007 0.489285 4.37007 0.329286C3.84007 0.169286 3.28007 0.479286 3.12007 1.00929L1.82007 5.40929C1.74007 5.69929 1.79007 6.00929 1.96007 6.25929C2.13007 6.50929 2.40007 6.66929 2.70007 6.68929L6.84007 7.04929H6.93007C7.44007 7.04929 7.88007 6.65929 7.93007 6.13929C7.98007 5.58929 7.57007 5.09929 7.02007 5.05929L5.44007 4.91929C8.56007 2.45929 13.1001 2.97929 15.5701 6.09929C18.0601 9.21929 17.5401 13.7793 14.4201 16.2593Z",
    fill: "#040031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/IconReset.a4003150a247dd49c98822c14e02229c.svg";
export { ForwardRef as ReactComponent };